module.exports = __webpack_public_path__ + "static/media/thumb.d71c8478.jpg";